export const INITIAL_STATE = {
    complaintTypes: [],
    couriers: [],
    customerTypes: [], 
    quantityCorrectionsProposals: [],
    termOfUseURL: '',
    allowMultiplePositionsForComplaint:false,
    isMyCompanyNotFoundCheckBoxVisible:false,
    isSerialNumberTooltipVisible:false
};


// WEBPACK FOOTER //
// ./src/reducers/state/Util.js